import { useContext } from "react";
import { BookerContext } from "./BookerContext";

export const useBookerContext = () => {
  const bookerContext = useContext(BookerContext);

  if (!bookerContext) {
    throw new Error(
      "useBookerContext must be used within a BookerContextProvider",
    );
  }

  return bookerContext;
};
